<!--
 * @Author: 仙道
 * @Date: 2022-04-23 17:56:48
 * @LastEditTime: 2022-06-04 10:21:04
 * @email: hao.li08@weimob.com
 * @Description:
 * @FilePath: /iplus-iwt-fe/src/views/equipment/account/modules/form/BaseInfo.vue
-->
<template>
  <div :loading="pageLoading" class="flex">
    <div class="w-150px flex justify-center items-start">
      <j-image-upload bizPath="scott/pic" v-if="pageType==='form'&&deviceId" v-model="model.pictureObjId"></j-image-upload>
      <img :src="model.pictureObjId" alt class="w-100px h-100px" v-if="pageType==='text'&&deviceId" />
    </div>
    <div class="flex-1">
      <a-form-model
        :label-col="{ span: 5 }"
        :model="model"
        :rules="validatorRules"
        :wrapper-col="{ span: 12 }"
        @submit="handleSumbit"
        class="ant-advanced-search-form w-1200px"
        ref="baseform"
      >
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="设备名称">
              <a-input placeholder="请输入设备名称/表号" v-model="model.devName" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="表号">
              <a-input class="w-full" placeholder="请输入表号" v-model="model.devTag" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item has-feedback label="设备类型">
              <a-select @ @change="modelChange" placeholder="请选择设备类型" v-model="model.devClassId">
                <a-select-option
                  :key="`dev`+item.value"
                  :value="item.value"
                  v-for="item in devClassList"
                >{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="设备状态">
              <j-dict-select-tag dictCode="dev_life_status" placeholder="请选择设备状态" v-model="model.serviceStatus" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="供水流域">
              <!-- <a-input class="w-full" placeholder="请输入供水流域" v-model="device.areaId" /> -->
              <a-select placeholder="请选择供水流域" v-model="model.areaId">
                <a-select-option :key="item.value" :value="item.value" v-for="item in areaList">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="供水流域">
              <a-select default-value="1" placeholder="请选择供水流域" v-model="model.devProcessId">
                <a-select-option
                  :key="`dev`+item.value"
                  :value="item.value"
                  v-for="item in devProcessList"
                >{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="重要性" prop="device_importance">
              <j-dict-select-tag dictCode="device_importance" placeholder="请选择重要性" v-model="model.importance" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="负责人">
              <!-- <j-select-multi-user :query-config="selectUserQueryConfig" v-model="device.multiUser" /> -->
              <j-select-user-by-dep :multi="false" v-model="model.multiUser"></j-select-user-by-dep>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="上级设备">
              <j-tree-select
                dict="dev_list,dev_name,id,del_flag=0 order by sort asc"
                hasChildField="is_leaf"
                pid-field="parent_id"
                pidValue
                v-model="model.parentId"
              ></j-tree-select>
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <a-row>
      <a-col :span="24" :style="{ textAlign: 'right' }">
        <a-button html-type="submit" type="primary">保存</a-button>
        <a-button :style="{ marginLeft: '8px' }" @click="handleReset">重置</a-button>
      </a-col>
        </a-row>-->
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="生产厂家">
              <!-- <a-input placeholder="请输入生产厂家" v-model="model.manuId" /> -->
              <a-select default-value="1" placeholder="请选择生产厂家" v-model="model.manuId">
                <a-select-option :key="item.id" :value="item.id" v-for="item in manuList">{{ item.manuName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="设备型号">
              <!-- <a-input v-model="model.modelCode" /> -->
              <a-select @change="modelChange" placeholder="请选择设备型号" v-model="model.modelName">
                <a-select-option :key="`dev`+item.id" :value="item.id" v-for="item in devModelList">{{ item.modelName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item has-feedback label="出厂日期">
              <j-date
                :showTime="true"
                dateFormat="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择出厂日期"
                v-model="model.factoryDate"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="出厂编号">
              <a-input placeholder="请输入出厂编号" v-model="model.factoryNumber" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="使用寿命">
              <!-- this.model.runningLife = model.runningLife -->
              <!--  -->
              <a-input placeholder="请输入使用寿命" v-model="model.runningLife" />
            </a-form-item>
          </a-col>
          <a-col :span="8" v-if="deviceId">
            <a-form-item has-feedback label="二维码">
              <div class="w-100px h-100px qcode relative">
                <!-- <img :preview="model.qrcode" :src="model.qrcode" alt class="w-80px h-80px absolute top-0 left-0" /> -->
                <j-image-upload
                  :disabled="true"
                  bizPath="scott/pic"
                  class="absolute top-0 left-0"
                  v-if="model.qrcode"
                  v-model="model.qrcode"
                ></j-image-upload>
                <!-- <img :src="model.qcode" alt class="w-80px h-80px absolute top-0 left-0" /> -->
              </div>
              <!-- <j-image-upload bizPath="scott/pic" v-model="model.qrcode"></j-image-upload> -->
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="连续运行">
              <!-- <a-input placeholder="请输入连续运行" v-model="model.continuousRunningDuration" /> -->
              <a-button @click="triggerText(1)" type="link">610小时</a-button>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="建议">
              <!-- <a-input placeholder="请输入建议" v-model="model.devTag" /> -->
              <a-button @click="triggerText(2)" type="link">48小时切换为备用</a-button>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="累计运行">
              <!-- <a-input placeholder="请输入累计运行" v-model="model.totalRunningDuration" /> -->
              <a-button @click="triggerText(3)" type="link">48小时切换为备用</a-button>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="下次维保">
              <!-- <j-date :showTime="true" dateFormat="YYYY-MM-DD HH:mm:ss" placeholder="请选择出厂日期" v-model="model.nextDate" /> -->
              <a-button @click="triggerText(4)" type="link">2022年10月24日</a-button>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24" :style="{ textAlign: 'right' }">
            <a-button html-type="submit" type="primary">保存</a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="handleReset">重置</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import DetailList from '@/components/tools/DetailList'
  import { cloneObject } from '@/utils/util'
  import { httpAction, getAction } from '@/api/manage'
  import { selectDropList, selectDevProcessList, selectDevClassList } from '@/api/device'
  import axios from 'axios'
  const DetailListItem = DetailList.Item
  export default {
    name: 'BaseInfo',
    components: {
      DetailList,
      DetailListItem
    },
    props: {
      propsData: {
        type: Object,
        default: () => { }
      },
      deviceId: {
        type: String,
        default: ''
      }
    },
    // 定义属性
    data () {
      return {
        Baseform: this.$form.createForm(this, { name: 'BaseInfoForm' }),
        model: {},
        accountItemTab: [
          {
            name: '生产厂家',
            k: 'accountName',
            v: ''
          },
          {
            name: '设备型号',
            k: 'accountName',
            v: ''
          }, {
            name: '出厂日期',
            k: 'accountDate',
            v: ''
          }, {
            name: '出厂编号',
            k: 'accountNo',
            v: ''
          }, {
            name: '保修时间',
            k: 'accountTime',
            v: ''
          }, {
            name: '二维码',
            k: 'accountCode',
            v: '223'
          }, {
            name: '连续运行',
            k: 'accountNumber',
            v: ''
          }, {
            name: '建议',
            k: 'accountQ',
            v: ''
          }, {
            name: '累计运行',
            k: 'accountTotal',
            v: ''
          }, {
            name: '下次维保',
            k: 'accountNext',
            v: ''
          }, {
            name: '剩余寿命',
            k: 'accountc',
            v: ''
          }
        ],
        validatorRules: {},
        manuList: [],
        url: {
          add: '/device/devList/add',
          edit: '/device/devList/edit',
          queryById: '/device/devList/queryDetailById',
          commonManufacturer: '/device/commonManufacturer/selectDropList',
          devModelList: '/device/devModel/selectDropList'
        },
        devClassList: [],
        devModelList: [],
        areaList: [],
        devProcessList: [],
        pageLoading: true,
        selectUserQueryConfig: []

      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters(['']),
      // deviceId () {
      //   return this.$route.query.accountId
      // },
      pageType () {
        return this.$route.query.pageType
      }

    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    async created () {
      this.getAreaList()
      this.getDevProcessList()
      this.getDevClassList()
      this.getCommonManufacturer()
      await this.getDevModelSelect()
      if (this.deviceId) {
        this.pageLoading = true
        getAction(this.url.queryById, { id: this.deviceId }).then(res => {
          this.model = res.result
          this.model.multiUser = 'smhgadmin'
          if (res.result.devTypeId) this.modelChange(res.result.devTypeId)
          this.pageLoading = false
        }).finally(() => {
          this.pageLoading = false
        })
      }
      const accountItemTab = cloneObject(this.accountItemTab)
      const propsData = cloneObject(this.propsData)

      const itemObject = accountItemTab.map(item => {
        if (Object.prototype.hasOwnProperty.call(propsData, item.k)) {
          item.v = propsData[item.k]
        }
        console.info(JSON.stringify(item))
        return item
      })

      this.accountItemTab = itemObject
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      modelChange (e) {
        const model = this.devModelList.find(item => item.id === e)

        this.model.pictureObjId = model.pictureObjId
        this.model.manuId = model.manuId
        this.model.runningLife = model.runningLife
        this.model.modelCode = model.modelCode
        this.model.devClassId = model.devClassId
      },
      async getDevModelSelect () {
        const modelList = await getAction(this.url.devModelList)
        this.devModelList = modelList.result.records
      },
      handleSumbit (e) {
        e.preventDefault()
        // this.Baseform.validateFields((error, values) => {
        //   console.log('error', error)
        //   console.log('Received values of form=====: ', values)
        // })
        const that = this
        // 触发表单验证
        this.$refs.baseform.validate(valid => {
          if (valid) {
            that.pageLoading = true
            // that.confirmLoading = true
            let httpurl = ''
            let method = ''

            if (!this.deviceId) {
              this.model.id = this.deviceId
              httpurl += this.url.add
              method = 'post'
            } else {
              this.model.id = this.deviceId
              httpurl += this.url.edit
              method = 'put'
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
              that.pageLoading = false
            }).finally(() => {
              that.pageLoading = false

              that.confirmLoading = false
            })
          }
        })
      },
      handleReset () {
        this.form.resetFields()
      },
      getAreaList () {
        selectDropList().then(res => {
          this.areaList = res.result.records.map(item => {
            return {
              value: item.id,
              label: item.areaName
            }
          })
        })
      },
      // 制造商
      async getCommonManufacturer () {
        const manuList = await getAction(this.url.commonManufacturer, '')
        this.manuList = manuList.result.records
      },
      getDevProcessList () {
        selectDevProcessList().then(res => {
          this.devProcessList = res.result.records.map(item => {
            return {
              value: item.id,
              label: item.processName
            }
          })
          this.model.devProcessId = this.devProcessList[0].value
        })
      },
      getDevClassList () {
        selectDevClassList().then(res => {
          this.devClassList = res.result.records.map(item => {
            return {
              value: item.id,
              label: item.typeName
            }
          })
        })
      },
      formatQrcode () {
        axios
          .get(`/code?code=${new Date()}`, {
            responseType: 'arraybuffer'
          })
          .then(response => {
            this.randomStr = response.headers.randomstr
            return 'data:image/png;base64,' + btoa(
              new Uint8Array(response.data)
                .reduce((data, byte) => data + String.fromCharCode(byte), '')
            )
          }).then(data => {
            this.codesrc = data
          })
      },
      handleUpload () {
        // this.$refs.imgupload.
      }
    }
  }
</script>

<style lang="less" scoped>
  .qcode {
    position: absolute;
  }
  /* .ant-advanced-search-form {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            min-height: 300px;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            .ant-form-item {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              margin-bottom: 16px;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          } */
  /* .ant-upload-select-picture-card {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        width: 40px;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        height: 40px;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      } */
</style>
